import React from 'react';

import { Category, Heading } from '../../../components';
import { cars } from '../../../constants';
import { getPopularCarCategories } from '../../../utils';

// import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const categories = getPopularCarCategories(cars);

const Categories = () => {

    return (

        <section>

            {/* Section heading */}
            <Heading title={'Explore Our Rental Cars'} subTitle={'Car Categories'} />

            <div className='category-slider'>

                <Swiper
                    // install Swiper modules
                    modules={[Autoplay]}
                    spaceBetween={10} // Space between slides
                    loop={true} // Enable infinite loop
                    autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
                    breakpoints={{
                        450: { slidesPerView: 1 }, // 1 slide for small screens
                        768: { slidesPerView: 2 }, // 2 slides for tablets
                        991: { slidesPerView: 3 }, // 3 slides for larger screens
                    }}
                >
                {categories.map(({ index, category, count, image }) => (
                    
                    <SwiperSlide key={index}>

                        <Category
                            key={index}
                            index={index}
                            category={category}
                            count={count}
                            image={image}
                        />

                    </SwiperSlide>
                    
                    ))}

                </Swiper>

            </div>

        </section>

    );
}

export default Categories;